export { default } from './part-reviews-and-contact-form';
